export default __webpack_public_path__ + "static/media/folder.be84159f.svg";